import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import ProgressiveLoader from "./components/loader/ProgressiveLoader";
import SnackBar from "./components/snack-bar/SnackBar";
import useFontScale from "./hooks/useFontScale";
import { getParams } from "./utlis/helpers";
import { getCustomTheme } from "./services/websiteApi";
import EmailVerification from "./components/emailVerification/EmailVerification";
import { FORGOT_PASSWORD, LOGIN, SIGNUP } from "./routes/routerPath";

const AUTH_PATHS = new Set(["/", LOGIN, SIGNUP, FORGOT_PASSWORD]);

const App = () => {
  const { loading, error } = useSelector((state) => state.global);
  const [loadingTheme, setLoadingTheme] = useState(false);
  const { providerId, adminId, clientId, emailVerificationToken } = getParams();
  const { pathname } = useLocation();
  const isAuthPath = AUTH_PATHS.has(pathname);
  // Initialize font scaling listener
  useFontScale();

  const callThemeAPI = async () => {
    await getCustomTheme()
      .then((res) => {
        sessionStorage.setItem("customtheme", JSON.stringify(res?.data?.data));
        document.documentElement.style.setProperty(
          "--primary-color",
          res?.data?.data?.primaryColorCode,
        );
        document.documentElement.style.setProperty(
          "--secondary-color",
          res?.data?.data?.secondaryColorCode,
        );
        setLoadingTheme(true);
      })
      .catch(() => {
        setLoadingTheme(true);
      });
  };
  useEffect(() => {
    if (emailVerificationToken) return;
    if (providerId && adminId && clientId) {
      callThemeAPI();
    } else {
      setLoadingTheme(true);
    }
  }, []);

  if (emailVerificationToken) {
    return <EmailVerification token={emailVerificationToken} />;
  }

  return (
    <div className={`mobile-app-shell ${isAuthPath ? "auth-shell" : ""}`}>
      {loadingTheme && <Outlet />}
      {loading && <ProgressiveLoader loader={loading} />}
      <SnackBar error={error} />
    </div>
  );
};

export default App;
